import React, { useState } from 'react';
import Axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import useCustomToast from 'src/hooks/useCustomToast';
import useEffectOnce from 'src/hooks/useEffectOnce';
import useLoading from 'src/hooks/useLoading';
import useQueryString from 'src/hooks/useQueryString';
import { setCotizacion } from 'src/reducers/Cotizacion/cotizacion.actions';
import { POST } from 'src/services';
import { urlGetCotizacionById, getPtpPagos } from 'src/services/urls';

const withCotizacion = (Component) => (props) => {
  const { cotizacion } = useSelector((state) => state.Cotizacion);
  const [errorCotizacion, setError] = useState(false);
  const Cotizacion = useSelector((state) => state.Cotizacion);

  const { values, setLoading, resetLoading, setSecundario } = useLoading();

  const dispatch = useDispatch();

  const params = useParams();
  const qParams = useQueryString();
  const history = useHistory();

  const toasts = useCustomToast();

  console.log('wit Params:', params);

  const init = async () => {
    if (!cotizacion && !errorCotizacion) {
      setLoading(true);
      setSecundario('Buscando información de la cotización...');

      console.log('FETCH WITH COTIZACION');

      const id = qParams?.id || params?.idCotizacion;
      //console.log('ID: ', props);
      const { error, ...data } = await POST(urlGetCotizacionById(id));

      if (error || !data.transaccion) {
        setError(true);
        return toasts.addErrorToast('HA OCURRIDO UN PROBLEMA.');
      }

      let data2 = { ...data?.cotizacion };

      let empresa = '';
      if (data2?.configuracion?.credencialesPtp?.empCodigo) {
        empresa = data2?.configuracion?.credencialesPtp.empCodigo;
      } else {
        switch (data2?.flujoPlugin) {
          case '6':
            break;
          case '7':
          case '9':
            empresa = data2?.producto?.codigoCore;
            break;
          case '10':
            break;
          default:
            empresa = data2?.empPtp;
            break;
        }
      }

      console.log('empresa' + empresa);


      try {
        const url = `${getPtpPagos(id, empresa)}`;
        const res = await Axios.get(url);

        if (res.statusText === 'OK') {
          if (res.data?.transaccion) {
            data2.historialPago = res.data?.data ?? [];
          }
        }
      } catch (error) {
        console.log('error consultando pago');
      }

      console.log({ SET_COTIZACION: data2 });
      dispatch(setCotizacion(data2));

      resetLoading();
    }
  };

  useEffectOnce(() => {
    init();
  });

  return (
    <LoadingWrapper {...values}>
      {cotizacion && (
        <Component
          {...{
            ...props,
            ...Cotizacion,
            ...toasts,
            // props,
            cotizacion,
            params,
            dispatch,
            history,
            Cotizacion,
            idCotizacion: cotizacion?.idCotizacion,
          }}
        />
      )}
    </LoadingWrapper>
  );
};

export default withCotizacion;
